<template>  
    <div class="d-flex flex-wrap">
        <v-chip v-if="classData.rescheduled && classData.status === 'scheduled'" x-small  class="px-2 font-weight-medium" dark color="indigo" label>
            <span v-if="!!classData.waiting_reschedule_request">Reschedule Requested</span>
            <span v-else>Rescheduled</span>
        </v-chip>
        <v-chip v-else-if="!classData.absent && !classData.canceled && !classData.scheduled" x-small  class="px-2 font-weight-medium" dark :color="handleStatus(classData.full_status).color" label>{{handleStatus(classData.full_status).text}}</v-chip>

        <v-chip v-if="classData.makeup" x-small  class="px-2 font-weight-medium ms-1" dark color="primary" label>
            <v-icon size="17" left class="me-1">mdi-sync</v-icon>
            <span>Makeup</span>
        </v-chip>

        <v-chip v-if="classData.absent" x-small  class="px-2 font-weight-medium ms-1" dark color="amber darken-1" label>
            <v-icon small left class="me-1">mdi-close-octagon-outline</v-icon>
            Absent
        </v-chip>
        
        <v-chip v-if="classData.canceled" x-small  class="px-2 font-weight-medium ms-1" dark color="red darken-1" label>
            <v-icon small left class="me-1">mdi-close</v-icon>
            Canceled
        </v-chip>

        <div v-if="classData.payment_status" class="d-flex ms-1">
            <v-chip v-if="classData.payment_status === 'trial'" x-small class="px-2 font-weight-medium" dark color="teal" label>
                <span>Trial</span>
            </v-chip>
            <v-chip v-else-if="classData.payment_status === 'paid' && !walletDisabled" x-small class="px-2 font-weight-medium" dark label>
                <v-icon size="16" left class="me-1">mdi-wallet-outline</v-icon>
                <span>Paid</span>
            </v-chip>
            <!-- <v-chip v-else-if="classData.payment_status === 'included'" x-small class="px-2 font-weight-medium" dark color="primary" label>
                <v-icon size="16" left class="me-1">mdi-check-circle-outline</v-icon>
                <span>Included</span>
            </v-chip> -->
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        classData: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
        }
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
    }
}
</script>

<style>

</style>